import { type AxiosInstance } from "axios";
import type {
  StoredCommercialPictureSearchResponse,
  StoredCommercialRequestSearchResponse,
} from "../types";
import type { StoredPictureSearchFormData } from "../components/storedPictureSearchConditionSchema";
import {
  buildStoredCommercialPictureSearchParams,
  type StoredPictureAcquirer,
  toIsOtherUserResource,
} from "../utils/storedPictureSearch";

/** 取得済商業登記 検索APIのパス */
export const STORED_COMMERCIAL_PICTURES_API_PATH =
  "/commercial-picture-request/stored-pictures/";

/**
 * 取得済商業登記を登記（明細）単位で検索する
 * @param apiClient APIクライアント
 * @param condition 検索条件（未指定の条件は送らない）
 * @param page ページ番号（1始まり）
 * @param pageSize 1ページの件数（最大100）
 * @param acquirer 取得したユーザーでの絞り込み
 * @returns 検索結果（総件数・ページ情報・一覧）
 */
export const searchStoredCommercialPicturesAPI = async (
  apiClient: AxiosInstance,
  condition: StoredPictureSearchFormData,
  page = 1,
  pageSize = 50,
  acquirer: StoredPictureAcquirer = "all"
): Promise<StoredCommercialPictureSearchResponse> => {
  const { data } = await apiClient.get<StoredCommercialPictureSearchResponse>(
    STORED_COMMERCIAL_PICTURES_API_PATH,
    {
      params: {
        ...buildStoredCommercialPictureSearchParams(condition),
        page,
        pageSize,
        isOtherUserResource: toIsOtherUserResource(acquirer),
      },
    }
  );
  return data;
};

export const searchStoredCommercialRequestsAPI = async (
  apiClient: AxiosInstance,
  condition: StoredPictureSearchFormData,
  page = 1,
  pageSize = 50,
  acquirer: StoredPictureAcquirer = "all"
): Promise<StoredCommercialRequestSearchResponse> => {
  const { data } = await apiClient.get<StoredCommercialRequestSearchResponse>(
    "/commercial-picture-request/stored-requests/",
    {
      params: {
        ...buildStoredCommercialPictureSearchParams(condition),
        page,
        pageSize,
        isOtherUserResource: toIsOtherUserResource(acquirer),
      },
    }
  );
  return data;
};

/** ダウンロード押下時に共有スコープ内の明細の署名URLを取得する。 */
export const downloadStoredCommercialPictureAPI = async (
  apiClient: AxiosInstance,
  detailId: number
): Promise<string | null> => {
  const { data } = await apiClient.get<{ downloadUrl: string | null }>(
    `${STORED_COMMERCIAL_PICTURES_API_PATH}${detailId}/download/`
  );
  return data.downloadUrl;
};
